import GeolocationInfoPanel from './src/GeolocationInfoPanel';

GeolocationInfoPanel.defineElement();
